import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import type {
  IGetBackofficeBids,
  IGetCargoes,
} from "~/features/cargo/api/types"
import type { RootState } from "~/store/store"

export interface ISelectedCargo extends IGetCargoes {
  currentBid?: IGetBackofficeBids
}

export interface CargoSelectionState {
  selectedCargo?: ISelectedCargo
}

export const initialCargoState: CargoSelectionState = {}

export const cargoSelectionSlice = createSlice({
  name: "cargo-selection",
  initialState: initialCargoState,
  reducers: {
    setSelectedCargo: (state, action: PayloadAction<IGetCargoes>) => {
      state.selectedCargo = {
        ...action.payload,
        currentBid: action?.payload?.bids
          ?.filter((bid) => bid.bidStatus == "Accepted")
          ?.at(-1),
      }
    },
  },
})

export const useCargoSelection = (): CargoSelectionState =>
  useSelector((state: RootState) => state.cargo)

export const { setSelectedCargo } = cargoSelectionSlice.actions

export default cargoSelectionSlice.reducer
